export const REACT_APP_API_URL     = process.env.REACT_APP_API_URL
export const REACT_APP_CLOUD_FRONT = process.env.REACT_APP_CLOUD_FRONT

export const serviceFeePercent = Number(process.env.REACT_APP_SERVICE_FEE_PERCENT) ?? 12
